const TodaysDate = () => {
  let currentDate = new Date().toISOString().slice(0, 10);
  return currentDate;
};

export default TodaysDate;
